import message from './message.json';

const ListMessage = {
  ...message,
};

export { ListMessage };
